import { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import routes from "../../routes/URL"
import { Container, Typography, Box, TextField, Button, Grid, Card, CardContent, CardHeader } from "@mui/material"
import Toast from "../../components/Toast";
import Header from "../../components/Header"

class CreateStaffScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      category_ids: [],
      category: [],
      active: true,
      toast: {
        open: false,
        message: "",
        severity: "success" 
      }
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  }
  
  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  }


  componentDidMount() {
       const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
    this.getCategory()
  }

  getCategory = async () => {
    const { status, message, data } = await API(this, "get", URL_PATH.listCategory(this.props.selectedHotelId.id))
    if (status == "success") {
      this.setState({
        category: data.map((item) => ({
          value: item.id,
          label: item.category_name,
        })),
      })
    } else {
      // Replace window.Alert with state update for error modal
      this.showToast(message, "error");
    }
  }

create = async () => {
  const formdata = new FormData(document.getElementById("staffForm"));
  formdata.append("hotel_id", this.props.selectedHotelId.id);
  formdata.append("role_id", 4);
  formdata.append("status", '"' + this.state.active + '"');

  console.log([...formdata.entries()]); // optional: to debug form data
  const { status, message, data } = await API(this, "post", URL_PATH.createUser, formdata);
  console.log(status, message, data);

  if (status == "success") {
    this.props.history.push(routes.admin.users.update((this.props.hotels[0]?.hotel_slug),data.id, "permissions"));
  } else {
    this.showToast(message, "error");
  }
};




  render() {
    return (
      <Container maxWidth="lg">
        {/* <Box sx={{ my: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            New Hotel Staff
          </Typography>
        </Box> */}

        <Card sx={{ backgroundColor: "#02111B",my: 4 , backgroundImage: "none", border: "1px solid #FFC857" }}>
          
           <CardHeader
            title={
              <Header title="Create New Staff" />

            }
            sx={{ pb: 2 }}
          />
          <CardContent>
            <form
              id="staffForm"
              name="staffForm"
              onSubmit={(e) => {
                e.preventDefault()
                return this.create()
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="User Full Name"
                    name="name"
                    placeholder="Enter User Full Name"
                    variant="outlined"
                    required
                  />
                </Grid>
 
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="User Email"
                    name="email"
                    type="email"
                    placeholder="Enter User Email"
                    variant="outlined"
                    required
                  />
                </Grid>



                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="User Mobile Number"
                    name="mobile"
                    placeholder="Enter User Mobile Number"
                    variant="outlined"
                    required
                  />
                </Grid>
<Grid item xs={12}>
  <TextField
    fullWidth
    label="Designation"
    name="designation"
    placeholder="Enter Designation (e.g., Manager)"
    variant="outlined"
    required
  />
</Grid>

                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{
                      bgcolor: "#FFC857",
                      "&:hover": { bgcolor: "#E6B54E" },
                    }}
                  >
                    Create Staff
                  </Button>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>

        <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        handleClose={this.handleCloseToast}
      />
      </Container>
    )
  }
}

export default redux(CreateStaffScreen)